import { Notification } from '@/core/components';
import { State } from '../state';

export const addNotification = (state: State, notification: Notification) => {
  state.notifications = [
    ...state.notifications,
    {
      ...notification,
      id: new Date().getTime() + state.notifications.length
    }
  ];
};

export const removeNotification = (state: State, id: number) => {
  state.notifications = state.notifications.filter((notification) => notification.id !== id);
};
